export default __webpack_public_path__ + "static/media/gallery_03.4e4349b5.jpg";